import {
	DEFAULT_DISCOUNT_SETTING_FLAG,
	DEFAULT_SHOW_OFFER_BUTTON,
	LS_IS_SHOW_BILL_DISCOUNT_AND_CD,
	LS_IS_SHOW_OFFER_BUTTON,
	LS_SHOW_DISCOUNT_AMT_EDITABLE,
} from "../constants/advanceOutletInvoicingConstants";

const readFlag = (key, defaultValue) => {
	const stored = localStorage.getItem(key);
	return stored !== null ? stored : defaultValue;
};

let showOfferButtonCache = null;
let billingPreviewFlagsCache = null;

/** Cached for session — AOI billing preview only */
export const getIsShowOfferButtonAtBillingPreview = () => {
	if (showOfferButtonCache === null) {
		showOfferButtonCache = readFlag(
			LS_IS_SHOW_OFFER_BUTTON,
			DEFAULT_SHOW_OFFER_BUTTON,
		);
	}
	return showOfferButtonCache;
};

export const getBillingPreviewFeatureFlags = () => {
	if (!billingPreviewFlagsCache) {
		const isShowBillDiscountAndCD =
			readFlag(LS_IS_SHOW_BILL_DISCOUNT_AND_CD, DEFAULT_DISCOUNT_SETTING_FLAG) ==
			1;
		const showDiscountAmtEditable =
			readFlag(LS_SHOW_DISCOUNT_AMT_EDITABLE, DEFAULT_DISCOUNT_SETTING_FLAG) == 1;
		billingPreviewFlagsCache = {
			isShowBillDiscountAndCD,
			showDiscountAmtEditable,
			isDetailedBillingView: isShowBillDiscountAndCD || showDiscountAmtEditable,
		};
	}
	return billingPreviewFlagsCache;
};
